<template>
	<div id="index">
		<div>
			<div class="result-filter flex flex-column-center flex-row-between">
				<div class="result-filter-left flex flex-column-center">
					<ByMultipleSelect ref="mode" v-model="modesCheckList" class="margin-left_16" model-key="name"
						:label-keys="['nameWithCount']" :list="formattedModePorts" placeholder="运输方式"
						type="placeholderNumber" @change="(val) => { modesChange(val); }" />

					<ByMultipleSelect v-model="originPortsCheck" class="margin-left_16" model-key="name"
						:label-keys="['nameWithCount']" :list="formattedOriginPorts" placeholder="起运城市"
						type="placeholderNumber" @change=" (val) => {originPortChange(val); }" />
					
					<div class="result-filter-right flex flex-column-center padding-right_16 margin-left_16">
						<button v-for="(item, index) in tabList" :key="index" type="button" :class="{
							'result-filter-right__btn margin-left_8': true,
							'result-filter-right__btn-active': selectNumber == index,
							}" @click="clickType(item, index)">
							<span>{{ item.title }}</span>
						</button>
					</div>
				</div>
			</div>
			
			<ExpResultList ref="PriceList" :sort-title="tabList[selectNumber].title" />
			
		</div>
	</div>
</template>

<script>
	import ExpResultList from './expResultList.vue'
	import ByMultipleSelect from '../../../home/byForm/ByMultipleSelect.vue'
	import BySliderSelect from '../../../home/byForm/BySliderSelect.vue'
	import {
		QueryPrice
	} from '/src/api/checkPrice.js'
	export default {
		name: 'Index',
		components: {
			// 组件的引用
			ExpResultList,
			ByMultipleSelect,
			BySliderSelect
		},
		props: {},
		data() {
			return {
				data: undefined,
				inputData: undefined,
				showItem: undefined,
				// ----------可拖拽选择范围组件
				priceRange: [],
				priceMin: 0,
				priceMax: 0,
				// 多选框
				modesCheckList: [],
				taxsCheckList: [],
				// /  tab切换
				tabList: [{
						title: '最超值',
						sortType: 1
					},
					{
						title: '时效最快',
						sortType: 2
					},
					{
						title: '价格最低',
						sortType: 3
					}
				],
				selectNumber: 0,
				bindData: undefined,
				timeRange: [],
				minTime: 0,
				maxTime: 0,
				modes: [],
				destinationPorts: [],
				originPorts: [],
				originPortsCheck: [],
				warehousePortsCheck:[]
			}
		},
		computed: {
			formattedModePorts() {
				return this.modes.map(port => ({
					nameWithCount: `${port.name} (${port.count})`,
					...port
				}))
			},
			formattedOriginPorts() {
				return this.originPorts.map(port => ({
					nameWithCount: `${port.name} (${port.count})`,
					...port
				}))
			},
			formattedWarehousePorts(){

			}
		},
		watch: {},
		created() {
			// 实例被创建之后执行代码
		},
		mounted() {
			// 页面进入时加载内容
		},
		methods: {
			reset() {
				this.modesCheckList = []
				this.originPortsCheck = []
				this.init(this.data, this.inputData)
			},
			destinationPortChange(val) {
				if (val.length > 0) {
					var selectList = []
					val.forEach((item) => {
						selectList.push(item.split('(')[0].trim())
					})
					this.bindData = this.data.list.filter((item) => {
						return (
							selectList.indexOf(item.destPortCode) >= 0 ||
							selectList.indexOf(item.destinationName) >= 0
						)
					})
				} else {
					this.bindData = this.data.list
				}
				this.$nextTick(() => {
					this.$refs.PriceList.init(this.bindData, this.inputData)
				})
			},
			originPortChange(val) {
				if (val.length > 0) {
					var selectList = []
					val.forEach((item) => {
						selectList.push(item.split('(')[0].trim())
					})
					this.bindData = this.data.list.filter((item) => {
						return (
							selectList.indexOf(item.startPortCode) >= 0 ||
							selectList.indexOf(item.originName) >= 0
						)
					})
				} else {
					this.bindData = this.data.list
				}
				this.$nextTick(() => {
					this.$refs.PriceList.init(this.bindData, this.inputData)
				})
			},
			warehousePortChange(val){

			},
			modesChange(val) {
				var selectModes = []
				var codes = []
				val.forEach((item) => {
					selectModes.push(
						this.modes.find((p) => item.indexOf(p.name) >= 0).value
					)
					if (item.indexOf('LCL+Express') >= 0) {
						codes.push('3')
					}
					if (item.indexOf('LCL+Truck') >= 0) {
						codes.push('5')
					}
				})
				if (selectModes.length == 0) {
					this.bindData = this.data.list
				} else {
					this.bindData = this.data.list.filter((item) => {
						var lcl =
							item.businessType === 3 && codes.indexOf(item.modeCodes) >= 0
						var other =
							item.businessType !== 3 &&
							selectModes.indexOf(item.businessType) >= 0
						return lcl || other
					})
				}

				this.$nextTick(() => {
					this.$refs.PriceList.init(this.bindData, this.inputData)
				})
			},
			priceChange(val) {
				this.bindData = this.data.list.filter((item) => {
					return (
						item.totalAmount >= this.priceRange[0] &&
						item.totalAmount <= this.priceRange[1]
					)
				})
				this.$nextTick(() => {
					this.$refs.PriceList.init(this.bindData, this.inputData)
				})
			},
			init(data, inputData) {
				this.data = data
				this.inputData = inputData
				this.$nextTick(() => {
					this.$refs.PriceList.init(data.list, inputData)
					var price = data.list.map((item) => item.totalAmount)
					this.priceMax = parseInt(Math.max(...price))
					this.priceMin = parseInt(Math.min(...price))
					this.priceRange = [this.priceMin, this.priceMax]
					this.timeRange = data.timeRange
					this.timeIndexRange = [0, this.timeRange.length - 1]
					this.minTime = 0
					this.maxTime = this.timeRange.length - 1
					this.modes = data.modes
					this.originPorts = data.originPorts
					this.destinationPorts = data.destinationPorts
				})
			},
			// 方法
			// 点击标题展开内容
			clkxShow(item) {
				this.showItem = item
			},
			clickType(item, index) {
				this.selectNumber = index
				this.inputData.SortType = item.sortType
				// 查价
				QueryPrice(this.inputData).then((res) => {
					if (res.code === 200) {
						this.init(res.data, this.inputData)
					}
				})
			},
			initPrice(inputData) {
				QueryPrice(inputData).then((res) => {
					if (res.code === 200) {
						this.init(res.data, inputData)
					}
				})
			}
		}
	}
</script>
<style scoped lang="scss">
	.result-index {
		padding-top: 24px;
		display: flex;

		.result-left {
			width: 280px;
			margin-right: 26px;
			background: #ffffff;
			border-radius: 8px;

			.result-left-title {
				height: 48px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 0 16px;
			}

			.menu-class {
				padding-left: 8px;
				margin: 0;

				li {
					overflow: hidden;
					cursor: pointer;

					.menu-title {
						height: 40px;
						justify-content: space-between;
						display: flex;
						margin: 0 16px 0 8px;
						align-items: center;
					}

					.menu-content {
						width: 232px;
						//height: 41px;
						background: rgba(242, 244, 248, 0.56);
						border-radius: 8px;
						padding: 16px;

						.range-title {
							text-align: left;
							font-size: 13px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #333333;
							margin-bottom: 8px;
						}

						::v-deep .el-checkbox {
							display: flex;
							margin: 6px 0;
						}
					}
				}
			}
		}

		.result-right {
			.result-tab {
				cursor: pointer;
				width: 894px;
				height: 40px;
				background: #eff1f5;
				border-radius: 20px;
				display: flex;
				align-items: center;
				font-size: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				color: #777777;

				.tab-class {
					width: 298px;
					height: 40px;
					line-height: 40px;
					font-size: 14px;
				}

				.active {
					background: #ffffff;
					border-radius: 20px;
					font-size: 14px;
					font-family: D-DINExp, D-DINExp;
					font-weight: bold;
					color: #e95506 !important;
					padding: 0 8px;
				}
			}
		}
	}

	.result-filter {
		width: 1200px;
		min-height: 56px;
		background: #ffffff;
		box-shadow: 0px 2px 8px 0px rgba(25, 78, 203, 0.04);
		border-radius: 8px;
		box-sizing: border-box;

		.result-filter-left {
			.range-title {
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #333333;
				line-height: 18px;
				text-align: left;
				font-style: normal;
			}

			.reset-text {
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #3370ff;
				line-height: 18px;
				text-align: right;
				font-style: normal;

				&:hover {
					cursor: pointer;
				}
			}
		}

		.result-filter-tax{
			display: flex;
			border-radius: 8px;
			background: #fff;
			overflow: hidden;
			border: 1px solid #e0e0e0;
			width: fit-content;
			.result-filter-tax__btn{
				outline: none;
				border: none;
				width: 64px;
				height: 32px;
				background: #fff;
				box-sizing: border-box;
				transition: all 0.3s;

				&:hover {
					cursor: pointer;

					span {
						font-weight: 600;
					}
				}

				span {
					display: inline-block;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 13px;
					color: #333333;
					line-height: 24px;
					text-align: center;
					font-style: normal;
				}
			}
			.result-filter-tax__btn:nth-child(2){
				border-left: 1px solid #d1cbcb;
				border-right: 1px solid #d1cbcb;
			}

			.result-filter-tax__btn-active {
				background: #3370FF;

				span {
					font-weight: 600;
					color: #fff;
				}
			}
		}

		.result-filter-right {
			.result-filter-right__btn {
				outline: none;
				border: none;
				width: 80px;
				height: 32px;
				background: rgba(0, 0, 0, 0.04);
				border-radius: 4px;
				box-sizing: border-box;
				transition: all 0.3s;

				&:hover {
					cursor: pointer;

					span {
						font-weight: 600;
					}
				}

				span {
					display: inline-block;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 13px;
					color: #777777;
					line-height: 24px;
					text-align: center;
					font-style: normal;
				}
			}

			.result-filter-right__btn-active {
				background: #3370FF;

				span {
					font-weight: 600;
					color: #fff;
				}
			}
		}
	}

	.slider-style ::v-deep .vue-slider {
		.vue-slider-process {
			background-color: #3370FF;
		}

		.vue-slider-dot-tooltip-inner {
			border-color: #3370FF;
			background-color: #3370FF;
		}

		.vue-slider-dot-tooltip-text {
			border-color: #3370FF;
			background-color: #3370FF;
		}
	}
</style>